import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import { useIntl } from "react-intl";

const DeleteIconButton = (props: IconButtonProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <Tooltip title={t({ id: "deleteLabel" })}>
      <IconButton {...props}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
};

export default DeleteIconButton;
